module.exports = __webpack_public_path__ + "images/line_bronze_eaf1175036d5152a01cbcc3c4f25c1e4.jpg";